import { createBrowserRouter } from 'react-router-dom';
import Layout from '../Layout';
import Home from '../pages/Home';

import Projects from '../pages/Projects/Projects';
import ProductDetail from '../pages/Projects/ProjectDetail';
// /Users/macair/Herd/youni-app/resources/pages/Services/ServiceDetail.jsx
import Services from '../pages/Services/Services';
import ServiceDetail from '../pages/Services/ServiceDetail';
import SimpleServiceDetail from '../pages/Services/SimpleServiceDetail';

import Contact from '../pages/Contact';
import Error404 from '../pages/Error404';

import ErrorBoundary from '../components/ErrorBoundary';

import { useParams } from 'react-router-dom';
import { useData } from '../contexts/DataContext';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

const ServiceWrapper = () => {
  const { slug } = useParams();
  const result = useData();
  
  const findServiceBySlug = (services, targetSlug) => {
    if (!services) return null;
    return Object.values(services).find(service => service.slug === targetSlug);
  };

  const service = findServiceBySlug(result.data?.services, slug);
  
  if (!service) {
    return <ErrorBoundary />;
  }

  return service.sub_services?.length > 0 ? <ServiceDetail /> : <SimpleServiceDetail />;
};

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        path: '/',
        element: <Home />
      },
      {
        path: '/contact',
        element: <Contact />
      },
      {
        path: '/projects',
        element: <Projects />
      },
      {
        path: '/project/:slug',
        element: <ProductDetail />
      },
      {
        path: '/services',
        element: <Services />
      },
      {
        path: '/service/:slug',
        element: <ServiceWrapper />
      },
      {
        path: '*',
        element: <Error404 />
      }
    ]
  }
]);
